import attrToBool from '../utils/attrToBool';
import keyboard from '../utils/keyboard';

const $ = jQuery;
const $toggle = $( '[data-toggle="dropdown"]' );

const getParent = $childEl => {
	return $childEl.parents( '.dropdown' );
};

const getDropdown = $childEl => {
	const $parent = getParent( $childEl );
	return $parent.find( '.dropdown-menu' );
};

const getToggle = $childEl => {
	const $parent = getParent( $childEl );
	return $parent.find( '.dropdown-toggle' );
};

const getLinks = $dropdown => {
	return $dropdown.find( 'a, button, input' );
};

const getOpenedToggle = () => {
	return $( '[data-toggle="dropdown"][aria-expanded="true"]' );
};

const toggle = $toggleBtn => {
	const isExpanded = attrToBool( $toggleBtn.attr( 'aria-expanded' ) );

	if ( ! isExpanded ) {
		show( $toggleBtn );
	} else {
		hide( $toggleBtn );
	}
};

const show = $toggleBtn => {
	const $dropdown = getDropdown( $toggleBtn );
	const $links = getLinks( $dropdown );

	$dropdown.addClass( 'show' );
	$toggleBtn.attr( 'aria-expanded', 'true' );
	positionDropdown( $dropdown );

	// Last link tab closes
	$links.last().on( 'keydown', closeOnLastTabOut );

	// Up, Down moves focus in links
	$links.on( 'keydown', arrowFocus );
};

const hide = $toggleBtn => {
	const $dropdown = getDropdown( $toggleBtn );
	const $links = getLinks( $dropdown );

	$dropdown.removeClass( 'show' );
	$toggleBtn.attr( 'aria-expanded', 'false' );

	// Off last link
	$links.last().off( 'keydown', closeOnLastTabOut );

	// Off arrow keys
	$links.off( 'keydown', arrowFocus );
};

const hideOther = $toggleBtn => {
	const $openedToggles = getOpenedToggle();

	$openedToggles.each( ( i, el ) => {
		if ( el !== $toggleBtn.get( 0 ) ) {
			hide( $( el ) );
		}
	} );
};

const positionDropdown = $dropdown => {
	const $wrapper = $dropdown.parents( '.dropdown-wrapper' );
	const gutter = 15;
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	const windowWidth = window.innerWidth - scrollbarWidth;
	const wrapperWidth = $wrapper.outerWidth();
	const wrapperLeftPos = $wrapper.get( 0 ).offsetLeft;
	const wrapperCenterPos = ( wrapperWidth / 2 ) + wrapperLeftPos;
	const dropdownWidth = $dropdown.outerWidth();

	$dropdown.removeClass( 'align-right align-left align-center' );

	if ( wrapperCenterPos + ( dropdownWidth / 2 ) > ( windowWidth - gutter ) ) {
		$dropdown.addClass( 'align-right' );
		return;
	}

	if ( wrapperCenterPos - ( dropdownWidth / 2 ) < gutter ) {
		$dropdown.addClass( 'align-left' );
		return;
	}

	$dropdown.addClass( 'align-center' );
};

const focus = ( $toggleBtn, focusTo ) => {
	const isExpanded = attrToBool( $toggleBtn.attr( 'aria-expanded' ) );

	if ( ! isExpanded ) {
		toggle( $toggleBtn );
	}

	const $dropdown = getDropdown( $toggleBtn );
	const $links = getLinks( $dropdown );

	const $focusEl = focusTo === 'first' ? $links.first() : $links.last();
	$focusEl.focus();
};

const closeOnLastTabOut = e => {
	if ( e.keyCode === keyboard.tab && ! e.shiftKey ) {
		const $link = $( e.currentTarget );
		const $toggleBtn = getToggle( $link );
		toggle( $toggleBtn );
	}
};

const arrowFocus = e => {
	const isDownKey = e.keyCode === keyboard.down ? true : false;
	const isUpKey = e.keyCode === keyboard.up ? true : false;

	if ( ! isDownKey && ! isUpKey ) {
		return;
	}

	e.preventDefault();

	const direction = isDownKey ? 'next' : 'prev';

	const $link = $( e.currentTarget );
	const $dropdown = getDropdown( $link );
	const $links = $dropdown.find( 'a, button, input' );

	const maxIndex = $links.length - 1;
	let currentIndex = null;

	$links.each( ( i, el ) => {
		if ( $( el ).is( ':focus' ) ) {
			currentIndex = i;
		}
	} );

	// On first link do nothing on prev
	if ( currentIndex === 0 && direction === 'prev' ) {
		return;
	}

	// On last link do nothing on next
	if ( currentIndex === maxIndex && direction === 'next' ) {
		return;
	}

	// Focus on next el
	const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
	$links.eq( nextIndex ).focus();
};

const hideOnEscape = e => {
	const $openedToggle = getOpenedToggle();

	if ( e.keyCode === keyboard.escape && $openedToggle.length ) {
		toggle( $openedToggle );
		$openedToggle.focus();
	}
};

const hideOnClick = e => {
	const $openedToggle = getOpenedToggle();

	if ( $openedToggle.length === 0 ) {
		return;
	}

	const $targetEl = $( e.target );
	const isToggleBtn = $targetEl.attr( 'data-toggle' ) === 'dropdown' ? true : false;

	// Second toggle btn clicked, close other dropdown
	if ( isToggleBtn && $openedToggle.length === 2 ) {
		return hideOther( $targetEl );
	}

	// Toggle btn clicked, ignore
	if ( isToggleBtn ) {
		return;
	}

	// Only one opened toggle and btn not clicked
	hide( $openedToggle );
};

const bind = () => {
	$toggle.on( 'click', e => {
		const $toggleBtn = $( e.currentTarget );
		toggle( $toggleBtn );
	} );

	// Shift Tab closes dropdown
	$toggle.on( 'keydown', e => {
		if ( e.keyCode === keyboard.tab && e.shiftKey ) {
			const $toggleBtn = $( e.currentTarget );
			const isExpanded = attrToBool( $toggleBtn.attr( 'aria-expanded' ) );

			if ( isExpanded ) {
				toggle( $toggleBtn );
			}
		}
	} );

	// Space, Enter opens dropdown without shifting focus
	$toggle.on( 'keydown', e => {
		if ( e.keyCode === keyboard.space || e.keyCode === keyboard.enter ) {
			e.preventDefault();
			const $toggleBtn = $( e.currentTarget );
			toggle( $toggleBtn );
		}
	} );

	// Down opens dropdown, focus first link
	// Up opens dropdown, focus last link
	$toggle.on( 'keydown', e => {
		if ( e.keyCode === keyboard.down || e.keyCode === keyboard.up ) {
			e.preventDefault();
			const focusTo = e.keyCode === keyboard.down ? 'first' : 'last';
			focus( $( e.currentTarget ), focusTo );
		}
	} );

	// Escape closes dropdown, return focus to btn
	$( document ).on( 'keydown', hideOnEscape );

	// Click off closes dropdown, return focus to btn
	$( document ).on( 'click', hideOnClick );
};

export default () => {
	if ( ! $toggle.length ) {
		return;
	}

	bind();
};
